export default __webpack_public_path__ + "static/media/step2.d475db44.webp";